export default {
  nav: {
    home: "Home",
    services: "Services",
    about: "About",
    testimonials: "Testimonials",
    contact: "Contact",
    requestQuote: "Contact Us",
  },
  hero: {
    headline: "We Equip Your Warehouse from A to Z",
    subheadline:
      "We provide comprehensive storage systems for factories and companies, including design, measurement, manufacturing, and professional installation to enhance warehouse efficiency. Everything you need in one place — with the highest standards from start to delivery.",
    cta: "Contact Us",
    scrollHint: "Scroll Down",
  },
  services: {
    sectionTitle: "Our Services",
    sectionDesc:
      "We offer comprehensive and innovative storage solutions that meet the needs of various sectors in the Kingdom",
    homeProductsEyebrow: "Our Products",
    homeProductsTitle: "Two Core Product Lines That Define Arafouf",
    homeProductsDesc: "We focus on heavy-duty warehouse racking and supermarket shelving as our two primary product lines, delivered with flexible sizing, smart design, and professional execution.",
    homeProductLabel: "Product",
    homeProductCta: "View details",
    warehouseTitle: "Heavy-Duty Warehouse Racking",
    warehouseDesc:
      "High-capacity industrial racking systems designed for warehouses and distribution centers with maximum durability and safety compliance",
    retailTitle: "Retail Display Shelving",
    retailDesc:
      "Modern retail shelving solutions designed to maximize product visibility and store layout efficiency",
    supermarketTitle: "Supermarket Solutions",
    supermarketDesc:
      "Complete supermarket shelving and storage systems including gondola shelving, refrigerated units, and checkout counters",
    card1Title: "Storage System Design",
    card1Desc: "We carefully study your site needs and design custom shelving systems based on space and product type to achieve maximum utilization.",
    card2Title: "High-Quality Shelf Manufacturing",
    card2Desc: "We manufacture warehouse and supermarket shelving with high standards of durability and endurance, using strong materials that last long.",
    card3Title: "Warehouse Supply & Preparation",
    card3Desc: "We supply all storage system components and deliver them on time, with full site preparation for smooth and organized installation.",
    card4Title: "Professional Shelf Installation",
    card4Desc: "Our technical team ensures precise and efficient shelf installation, considering safety and stability factors so your facility is ready to work immediately.",
    card5Title: "Custom Measurement & Design",
    card5Desc: "We start by visiting your site and taking accurate measurements, then create an engineering design that matches your business nature and warehouse space.",
    card6Title: "Integrated Storage Systems",
    card6Desc: "We provide customized storage solutions that meet the needs of factories and companies with a high level of efficiency and organization.",
    pageTitle: "Arafouf Services",
    pageDesc: "Comprehensive storage solutions for warehouses, factories, and retail stores",
    talkServicesEyebrow: "Service Inquiries",
    talkToUs: "Talk to Us",
    talkDesc: "Do you have any questions? We are always ready to talk about your business, new projects, creative opportunities, and how we can help you.",
    contactButton: "Contact Us",
    whatsappButton: "WhatsApp",
  },
  about: {
    label: "",
    line1: "Leading Provider",
    line2: "of Industrial Storage",
    line3: "in Saudi Arabia",
    subtitle: "Serving Riyadh, Jeddah, Dammam & Beyond",
    servicesButton: "Explore Our Services",
    pageTitle: "About Arafouf",
    companyDesc: "Arafouf Towers is a Saudi company specialized in equipping and installing warehouse shelving, supermarket shelves, and commercial markets. We provide practical and innovative solutions to organize spaces and improve work efficiency, through durable shelving systems designed according to customer needs and installed by expert hands.",
    visionTitle: "Our Vision",
    visionDesc: "To be the first choice in the Kingdom in the field of warehouse equipment and shelving system installation, by providing professional services, smart designs, and superior quality execution.",
    goalsTitle: "Our Goals",
    goalsList: [
      "Provide practical and effective storage solutions for each client according to their needs",
      "Build long-term relationships with our clients based on trust and satisfaction",
      "Improve operational efficiency of warehouses and commercial stores",
      "Continuous innovation in shelving designs and systems that keep up with market requirements",
    ],
    historyTitle: "Our History",
    historySubtitle: "Years of Journey",
    historyDesc: "Since our establishment, we have been striving to provide the best storage solutions in the Kingdom of Saudi Arabia. With every project we complete, we build a strong reputation based on quality and professionalism.",
    whyTitle: "Why Choose Arafouf?",
    whyCards: [
      {
        title: "Smart Design",
        desc: "We offer carefully designed shelving systems to achieve maximum space utilization, whether in large warehouses or small groceries.",
      },
      {
        title: "Exceptional Support",
        desc: "Our team is always available to answer your inquiries, provide technical consultations, and offer after-sales support for a comfortable experience from start to finish.",
      },
      {
        title: "Professional Execution",
        desc: "We rely on a specialized technical team in installation, working according to the highest quality and safety standards.",
      },
      {
        title: "Competitive Prices",
        desc: "We offer the best possible quality at thoughtful prices, without compromising on professionalism.",
      },
    ],
  },
  testimonials: {
    label: "Client Testimonials",
    heading: "Trusted by Leading Saudi Businesses",
  },
  cta: {
    heading: "Get Your Custom Storage Solution",
    desc1: "Free consultation and site assessment",
    desc2: "Delivery and installation across Saudi Arabia",
    button: "Contact Us",
  },
  contact: {
    pageTitle: "Contact Us",
    pageDesc: "Get in touch with us for a free consultation and a custom quote for your project",
    phoneLabel: "Phone",
    phoneNumber: "+966 53 278 5554",
    emailLabel: "Email",
    emailAddress: "care@info.arafouf.sa",
    locationLabel: "Location",
    locationName: "Arafouf Establishment",
    address1: "Al-Jazirah District",
    address2: "Riyadh, Saudi Arabia",
    hoursLabel: "Working Hours",
    hoursValue: "Sat - Thu: 8:00 AM - 5:00 PM",
    formTitle: "Send Your Inquiry",
    dataNotice: "We collect the information you submit in this form (name, phone number, email, city, and message) to contact you, review your request, and provide a suitable service quotation. We do not use this data for unrelated purposes.",
    policyConsentStart: "I agree to the",
    policyConsentAnd: "and",
    policyConsentEnd: "and I acknowledge how my data is collected and processed as described.",
    formErrors: {
      submit: "An error occurred while submitting. Please try again.",
      network: "A network error occurred. Please try again later.",
    },
    submitLoading: "Submitting...",
    submitButton: "Send",
    successMessage: "Thank You for Contacting Us",
    successDesc: "Your request has been received successfully and we will contact you soon",
  },
  footer: {
    brand: "Arafouf",
    tagline: "Storage Solutions Provider",
    solutionsTitle: "Solutions",
    warehouseRacking: "Warehouse Racking",
    retailShelving: "Retail Shelving",
    supermarketSystems: "Supermarket Systems",
    customProjects: "Custom Projects",
    contactTitle: "Contact",
    phone: "+966 53 278 5554",
    email: "care@info.arafouf.sa",
    locationTitle: "Location",
    locationName: "Arafouf Establishment",
    address1: "Al-Jazirah District",
    address2: "Riyadh, Saudi Arabia",
    newsletterTitle: "Stay Updated",
    newsletterPlaceholder: "Your email address",
    newsletterButton: "Subscribe",
    socialLinkedIn: "LinkedIn",
    socialInstagram: "Instagram",
    socialTwitter: "Twitter",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    copyright: "2025 Arafouf Storage Solutions",
  },
  legal: {
    privacy: {
      pageTitle: "Privacy Policy",
      metaTitle: "Privacy Policy | Arafouf",
      metaDesc: "This Privacy Policy explains how Arafouf collects, uses, protects, and processes personal data when you use our website and contact form.",
      intro: "At Arafouf, we are committed to protecting your privacy and handling your data responsibly and transparently. By using our website or submitting a contact request, you agree to the practices described in this policy.",
      updatedAt: "Last updated: May 9, 2026",
      sections: [
        {
          title: "1. Information We Collect",
          paragraphs: [
            "When you use our contact form, we may collect information you provide directly to help us serve you effectively.",
          ],
          bullets: [
            "Full name",
            "Mobile phone number",
            "Email address",
            "City",
            "Message or inquiry details",
            "Basic technical data such as browser type and usage logs for performance and security",
          ],
        },
        {
          title: "2. How We Use Your Data",
          paragraphs: [
            "We use collected data only for service-related and communication-related purposes.",
          ],
          bullets: [
            "Responding to inquiries and quotation requests",
            "Contacting you regarding service details or site visits",
            "Improving website quality and user experience",
            "Complying with legal and regulatory requirements when applicable",
          ],
        },
        {
          title: "3. Data Sharing with Third Parties",
          paragraphs: [
            "We do not sell or rent your personal data. We may share minimum necessary data with trusted technical service providers (such as hosting, analytics, or maps providers) strictly to operate and improve our website, and in line with this policy.",
          ],
        },
        {
          title: "4. Data Retention",
          paragraphs: [
            "We retain personal data only for as long as needed to fulfill the purpose for which it was collected, or as required by applicable law. Afterwards, data is deleted or anonymized securely.",
          ],
        },
        {
          title: "5. Data Protection",
          paragraphs: [
            "We apply reasonable organizational and technical safeguards to protect your data from unauthorized access, misuse, alteration, disclosure, or unlawful destruction.",
          ],
        },
        {
          title: "6. Cookies",
          paragraphs: [
            "Our website may use cookies and similar technologies to analyze performance and improve your browsing experience. You may manage cookie settings through your browser.",
          ],
        },
        {
          title: "7. Your Rights",
          paragraphs: [
            "You may request access to your personal data, request corrections, or request deletion, subject to legal and regulatory limitations.",
          ],
        },
        {
          title: "8. Privacy Contact",
          paragraphs: [
            "For privacy-related questions or requests regarding your personal data, please contact us at:",
          ],
          bullets: [
            "Email: care@info.arafouf.sa",
            "Phone: +966 53 278 5554",
          ],
        },
      ],
    },
    terms: {
      pageTitle: "Terms of Service",
      metaTitle: "Terms of Service | Arafouf",
      metaDesc: "These Terms of Service define the rules governing the use of Arafouf's website and the provision of shelving and storage-related services.",
      intro: "These terms govern your use of Arafouf's website and services. Please read them carefully before submitting requests or using any of our services.",
      updatedAt: "Last updated: May 9, 2026",
      sections: [
        {
          title: "1. Acceptance of Terms",
          paragraphs: [
            "By using this website or submitting the contact form, you acknowledge and accept these Terms and the associated Privacy Policy.",
          ],
        },
        {
          title: "2. Scope of Services",
          paragraphs: [
            "We provide design, supply, preparation, manufacturing, and installation services for shelving systems for warehouses and retail businesses, subject to project requirements and final agreement.",
          ],
        },
        {
          title: "3. Quotations and Contracting",
          paragraphs: [
            "Any quotation provided through the website or direct communication is preliminary and non-binding unless the final scope is approved and a commercial agreement is signed by both parties.",
          ],
          bullets: [
            "Prices may be updated based on the final approved scope",
            "Delivery and execution timelines are estimates unless otherwise stated in contract",
            "Advance payments may be required depending on project type",
          ],
        },
        {
          title: "4. Customer Responsibilities",
          paragraphs: [
            "The customer is responsible for providing accurate information, ensuring timely site access, and preparing the site environment to support safe and efficient execution.",
          ],
        },
        {
          title: "5. Execution and Safety",
          paragraphs: [
            "We strive to execute work according to professional best practices and safety standards. Timelines may be impacted by circumstances beyond our control, such as supply delays or on-site constraints.",
          ],
        },
        {
          title: "6. Intellectual Property",
          paragraphs: [
            "All website content (including text, designs, images, and logos) is owned by or licensed to Arafouf and may not be reused without prior written permission.",
          ],
        },
        {
          title: "7. Limitation of Liability",
          paragraphs: [
            "The website and its content are provided on an 'as is' basis. To the extent permitted by law, we are not liable for indirect, incidental, or consequential damages resulting from website use.",
          ],
        },
        {
          title: "8. Cancellation or Rescheduling",
          paragraphs: [
            "Cancellation and rescheduling terms are governed by the applicable commercial agreement. Fees or operational impacts may apply if cancellation occurs after execution or manufacturing has begun.",
          ],
        },
        {
          title: "9. Governing Law",
          paragraphs: [
            "These terms are governed by the laws and regulations of the Kingdom of Saudi Arabia. Competent courts within the Kingdom shall have jurisdiction over disputes arising from these terms.",
          ],
        },
        {
          title: "10. Contact",
          paragraphs: [
            "For legal or operational questions related to these terms, please contact us at:",
          ],
          bullets: [
            "Email: care@info.arafouf.sa",
            "Phone: +966 53 278 5554",
          ],
        },
      ],
    },
  },
  meta: {
    homeTitle: "Arafouf | Comprehensive Storage Solutions for Warehouses & Retail",
    homeDesc: "Arafouf Towers - We equip your warehouse from A to Z. Design, measurement, manufacturing, and professional installation of storage systems for factories and companies in Saudi Arabia.",
    servicesTitle: "Arafouf Services | Design, Manufacturing & Installation of Storage Systems",
    servicesDesc: "We offer comprehensive storage solutions: design, manufacturing, supply, installation, and custom measurement. Expertise in warehouse, supermarket, and retail shelving.",
    aboutTitle: "About Us | Arafouf Storage Solutions Saudi Arabia",
    aboutDesc: "Learn about Arafouf Towers - the leading Saudi company in equipping and installing warehouse and commercial market shelving since 1995.",
    contactTitle: "Contact Us | Arafouf - Free Consultation",
    contactDesc: "Contact Arafouf for a free consultation. We provide comprehensive storage solutions for factories and companies across Saudi Arabia.",
    thankYouTitle: "Thank You | Your Request Received - Arafouf",
    thankYouDesc: "Your request has been received successfully. The Arafouf team will contact you soon to provide the best storage solutions for your project.",
  },
};